import throttle from 'lodash/throttle';

export default {
  name: 'FlPagedList',
  data() {
    return {
      items: [],
      meta: {},
      path: null,
      params: {},
      fetching: false,
    };
  },
  async mounted() {
    window.addEventListener('scroll', throttle(this.autoPager, 200));
    window.addEventListener('resize', throttle(this.getUpdatePage, 200));
  },
  destroyed() {
    window.removeEventListener('scroll', this.autoPager);
    window.removeEventListener('resize', this.getUpdatePage);
  },
  methods: {
    async throttledAutoPager() {
      return throttle
    },
    async autoPager(){},
    async getUpdatePage(){},
    async getPage(index: number) {
      if (this.fetching) {
        return null;
      }
      console.log('parent getPage');
      if (!this.path) {
        return null;
      }

      const params = this.calculatedParams;
      if (typeof index === 'number' && index !== 0) {
        params.page = index;
      }

      try {
        this.fetching = true;
        const result = await this.axios.get(this.path, params);
        if (result.status === 200) {
          this.items = [...this.items, ...result.data.data];
          this.fetching = false;
          return result.data.data;
        }
      } catch (error) {
        console.error(error);
        this.fetching = false;
        return null;
      }
    },
  },
  computed: {
    calculatedParams() {
      const calcParams = Object.assign({}, this.params);
      calcParams['per'] = 100;
      return calcParams;
    },
  },
};
